module.exports = __webpack_public_path__ + "img/1534238607.deb3bc7d.jpg";